import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useIsAuthenticated } from "@auth/hooks/useIsAuthenticated";
import { RouteTo } from "@routing/RouteMap";

/**
 * Bestimmt die Router bei Page-Load und leitet unbekannte Routen um.
 */
const RedirectPage = () => {
    const navigate = useNavigate();
    const isAuthenticated = useIsAuthenticated();

    // TODO Überlege, ob store.app.isLoading setzt

    useEffect(() => {
        isAuthenticated ? navigate(RouteTo.DASHBOARD) : navigate(RouteTo.LOGIN);
    }, [isAuthenticated, navigate]);

    return <></>;
};

export default RedirectPage;
